import { Box, Button, Container, CssBaseline, TextField } from "@mui/material";
import { useState } from "react";
import { sendEmailWithEventimAPIByCostumerNumber } from "../../fetchers/RFIDTickets";

const SendEmailComponent = () => {
  const [costumerNumber, setCostumerNumber] = useState<number>();
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!costumerNumber) {
      alert("אנא הזן מספר לקוח");
      return;
    }

    setLoading(true);
    try {
      const response = await sendEmailWithEventimAPIByCostumerNumber(costumerNumber);

      if (response && response.StatusId === 1) {
        alert("האימייל נשלח בהצלחה!");
        setCostumerNumber(undefined);
      } else {
        alert("שליחת האימייל נכשלה. נסה שוב.");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      alert("שליחת האימייל נכשלה עקב שגיאה.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xl" className="new-club-page-container">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          marginBottom: 4,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <div className="title" style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
          הכנס מספר לקוח
        </div>
        <TextField
          label="מספר לקוח"
          variant="outlined"
          type="number"
          value={costumerNumber || ""}
          onChange={(e) => {
            const value = e.target.value;
            const numberValue = value === "" ? undefined : Number(value);
            setCostumerNumber(numberValue);
          }}
          sx={{ width: "300px" }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={loading}
          sx={{ width: "300px" }}
        >
          {loading ? "שולח..." : "שלח מייל"}
        </Button>
      </Box>
    </Container>
  );
};

export default SendEmailComponent;
